module.exports = __webpack_public_path__ + "img/onenorth-cover.cd3a64bd.jpg";